import React, { useState } from 'react';
import Layout from '../components/Layout';
import { API } from '../api';
import { toast } from 'react-toastify';

export default function ChangePassword() {

  const [form, setForm] = useState({
    user_id: '',
    old_password: '',
    new_password: '',
    confirm_password: ''
  });

  // SUBMIT
  const handleSubmit = async () => {

    console.log("Old Password:", form.old_password);

    
  
    try {
      const res = await API.post('/users/change-password', {
        user_id: form.user_id,
        old_password: form.old_password,
        new_password: form.new_password
      });
  
      alert(res.data.message);
  
    } catch (err) {
      alert(err.response?.data?.message || "Error");
    }
  };

  return (
    <Layout activePage="Change Password">

      <div style={S.card}>
        <h2>Change Password</h2>

        <input
          placeholder="User Id"
          value={form.user_id}
          onChange={e=>setForm({...form,user_id:e.target.value})}
        />

        <input
          type="password"
          placeholder="Old Password"
          value={form.old_password}
          onChange={e=>setForm({...form,old_password:e.target.value})}
        />

        <input
          type="password"
          placeholder="New Password"
          value={form.new_password}
          onChange={e=>setForm({...form,new_password:e.target.value})}
        />

        <input
          type="password"
          placeholder="Confirm New Password"
          value={form.confirm_password}
          onChange={e=>setForm({...form,confirm_password:e.target.value})}
        />

        <button onClick={handleSubmit}>
          Change Password
        </button>
        
      </div>

    </Layout>
  );
}

const S = {
    card: {
      background: '#fff',
      padding: 20,
      borderRadius: 10,
      maxWidth: 400,
      margin: '20px auto',
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  };